import { DOMAIN_NAME } from "../constants";

export function LegalFooter() {
  return (
    <footer className="mt-auto w-full bg-slate-700 px-4 py-6 text-slate-300">
      <div className="mx-auto max-w-lg space-y-4 text-[11px] leading-relaxed">
        <p>
          <strong className="text-slate-200">Disclaimer:</strong> {DOMAIN_NAME} is a free estimation engine and
          service to assist homeowners in connecting with local service providers. All contractors/providers are
          independent and {DOMAIN_NAME} does not warrant or guarantee any work performed. It is the responsibility
          of the homeowner to verify that the hired contractor furnishes the necessary license and insurance
          required for the work being performed. All prices provided are estimates and do not constitute an
          official quote.
        </p>
        <p>
          <strong className="text-slate-200">Service Availability Notice:</strong> Same-day and emergency services
          are subject to provider participation, location, technician availability, and demand. Availability is not
          guaranteed and may vary by market and appointment capacity.
        </p>
      </div>
    </footer>
  );
}
